// Whether what is on screen came off the network or out of the service
// worker's cache. The SW stamps its cache fallbacks (see the NetworkFirst rule
// in vite.config.ts); useApi reports every load here, and one banner renders
// the answer for the whole app.

const EVENT = "data-staleness";

// A number, not a Date: useSyncExternalStore re-reads the snapshot on every
// render and needs a stable identity for an unchanged value.
// null = live, 0 = cached but the age was unreadable, otherwise epoch ms.
let cachedAt: number | null = null;

// The most recent load wins. Screens fetch from one source at a time — a page
// is either live or it is being served the whole cached set — so there is no
// need to reference-count the mounted hooks.
export function reportLoad(stampedAt: string | null): void {
  let next: number | null = null;
  if (stampedAt !== null) {
    const parsed = new Date(stampedAt).getTime();
    next = Number.isNaN(parsed) ? 0 : parsed;
  }
  if (next === cachedAt) return;
  cachedAt = next;
  window.dispatchEvent(new Event(EVENT));
}

export function getCachedAt(): number | null {
  return cachedAt;
}

export function onStalenessChange(cb: () => void): () => void {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
}
